import ResyRewardsBanner from './ResyRewardsBanner';

export default ResyRewardsBanner;
